module.exports = __webpack_public_path__ + "img/3.08862c6f.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1062,"height":1448,"variants":[{"file":"img/3-480w.4425dc901f4f.webp","width":480},{"file":"img/3-960w.c9c6888dd642.webp","width":960},{"file":"img/3-1062w.0b3237d4869b.webp","width":1062}]};
}